import reducer from './reducers';

import * as modalsSelectors from './selectors';
import * as modalsOperations from './operations';
import * as modalsTypes from './types';

export { modalsSelectors, modalsOperations, modalsTypes };

export default reducer;
